import React from 'react';
import { RecentScreen } from './types';
import {
  Jurisdiction,
  ScreeningProfile,
  jurisdictionOf,
  routeLabel,
} from './profiles';
import { riskTone, shortDate, titleCase } from './utils';
import { RecentRow } from './ComposerParts';

interface RowProps {
  profile: ScreeningProfile;
  screen: RecentScreen;
  onPick: (r: RecentScreen) => void;
  className?: string;
}

export const RecentScreenRow: React.FC<RowProps> = ({
  profile,
  screen,
  onPick,
  className,
}) => {
  const tone = screen.risk ? riskTone(screen.risk) : 'none';
  return (
    <RecentRow
      title={screen.q}
      meta={routeLabel(
        profile,
        jurisdictionOf(profile, screen.jurisdiction),
        screen.partner,
        `No ${profile.partner.key}`,
      )}
      tone={tone}
      pill={screen.risk ? titleCase(screen.risk) : 'Not evaluated'}
      count={`${screen.matches.toLocaleString()} ${
        screen.matches === 1 ? 'match' : 'matches'
      }`}
      when={shortDate(screen.at)}
      onPick={() => onPick(screen)}
      className={className}
    />
  );
};

interface Props {
  profile: ScreeningProfile;
  jurisdiction: Jurisdiction;
  recents: RecentScreen[];
  recordTotal: number | null;
  onPick: (r: RecentScreen) => void;
  onBrowse: () => void;
}

const RecentScreens: React.FC<Props> = ({
  profile,
  jurisdiction,
  recents,
  recordTotal,
  onPick,
  onBrowse,
}) => (
  <div className='psc-recents'>
    {recents.length > 0 && (
      <>
        <h2 className='psc-h2'>RECENT SCREENS</h2>
        {recents.map((r) => (
          <RecentScreenRow
            key={`${r.q}-${r.at}`}
            profile={profile}
            screen={r}
            onPick={onPick}
          />
        ))}
      </>
    )}
    <p className='psc-empty-line'>
      No product in mind?{' '}
      <button type='button' className='psc-link' onClick={onBrowse}>
        {jurisdiction.countsRecords && recordTotal !== null
          ? `Browse the ${recordTotal.toLocaleString()} ${
              jurisdiction.noun
            } records by filter`
          : `Browse every ${jurisdiction.noun} record by filter`}
      </button>{' '}
      — pick lenses, lists or HTS chapters and run with the field empty.
    </p>
  </div>
);

export default RecentScreens;
